import React from 'react';
import { RiCheckboxCircleFill } from 'react-icons/ri';
import { motion } from 'framer-motion';
import { useNavigate } from '@tanstack/react-router';
import { AuthHeader } from './AuthHeader';

export const PasswordResetSuccessPage: React.FC = () => {
  const navigate = useNavigate();

  return (
    <div className="relative min-h-screen w-full flex bg-[#030303] flex-col overflow-hidden font-['Inter'] selection:bg-blue-500/30">
      {/* Background Glow */}
      <div
        className="absolute pointer-events-none rounded-full"
        style={{
          width: '1308px',
          height: '449px',
          bottom: '-150px',
          left: '50%',
          transform: 'translateX(-50%)',
          background: 'linear-gradient(to right, #2F80ED, #942FED)',
          opacity: 0.5,
          filter: 'blur(260px)',
          zIndex: 0,
        }}
      />

      <AuthHeader />

      {/* Main Content */}
      <div className="relative z-10 flex-1 flex flex-col items-center justify-center w-full max-w-[500px] mx-auto px-6 py-20">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.5 }}
          className="flex flex-col items-center text-center"
        >
          {/* Success Checkmark */}
          <div className="mb-8 flex justify-center">
            <motion.div
              initial={{ scale: 0 }}
              animate={{ scale: 1 }}
              transition={{
                type: 'spring',
                stiffness: 260,
                damping: 20,
                delay: 0.2,
              }}
              className="relative"
            >
              {/* Glow Effect */}
              <div className="absolute inset-0 bg-green-500/20 blur-2xl rounded-full" />

              <div className="relative w-24 h-24 rounded-full bg-green-500/10 flex items-center justify-center text-green-500 border border-green-500/20 shadow-2xl shadow-green-500/20">
                <RiCheckboxCircleFill size={64} />
              </div>
            </motion.div>
          </div>

          <h1
            className="text-white text-[32px] md:text-[40px] font-medium leading-[1.1] mb-4"
            style={{ fontFamily: "'Funnel Display', sans-serif" }}
          >
            Password reset successful
          </h1>
          <p className="text-[#a1a1aa] text-[15px] font-medium leading-relaxed max-w-[380px] mx-auto mb-10">
            Your password has been updated. You can now sign in to your Musicade account.
          </p>

          <button
            onClick={() => navigate({ to: '/sign-in' })}
            className="h-[56px] w-full bg-[#3B82F6] hover:bg-[#2563EB] text-white font-semibold text-[16px] rounded-2xl transition-all shadow-xl shadow-blue-500/20 active:scale-[0.98] cursor-pointer"
          >
            Sign in
          </button>
        </motion.div>
      </div>
    </div>
  );
};
